import axios from 'axios';

import { ApplyLinkDto } from '../interfaces/apply-link.interface';
import { SendApplicationRequestDto } from '../interfaces/send-application-request.interface';

class ApplyLinkService {
  /** The unit's active links, the caller's first. Any seat that can view the unit may list them. */
  async list(propertyId: string): Promise<ApplyLinkDto[]> {
    const response = await axios.get<ApplyLinkDto[]>(`apply-link/property/${propertyId}`);

    return response.data;
  }

  /**
   * Records the confirmations the form showed and gives the caller a link if they have none; renewing a paused one
   * is the same call and keeps its URL. Answers with the unit's links, as `list` does.
   */
  async confirmAndCreate(propertyId: string, requestData: SendApplicationRequestDto): Promise<ApplyLinkDto[]> {
    const response = await axios.post<ApplyLinkDto[]>(`apply-link/property/${propertyId}`, requestData);

    return response.data;
  }

  /** Turns off the caller's own link for the unit; the URL stops working for good. */
  async revokeOwn(propertyId: string): Promise<void> {
    await axios.delete(`apply-link/property/${propertyId}`);
  }
}

export default new ApplyLinkService();
